import * as React from 'react';
import { Dayjs } from 'dayjs';
import { useTranslation } from '@/src/i18n';

type ComponentProps = {
  fromText: string;
  fromDay?: string;
  dayText?: string;
  monthText: string;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const SearchCardFirstAvailabilityComponent = (props: ComponentProps) => {
  const { fromText, fromDay, dayText, monthText, onClick } = props;

  return (
    <div
      className="killon1023 next-availability"
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        onClick(e);
      }}
    >
      <p>{fromText}</p>
      <p>
        {fromDay && <span className="day">{fromDay}</span>}
        {dayText && (
          <>
            <span className="date">{dayText}</span>
            <br />
          </>
        )}
        <span className="month">{monthText}</span>
      </p>
    </div>
  );
};

type Props = {
  firstFreeTimeslotdayjs: Dayjs;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const SearchCardFirstAvailability = (props: Props) => {
  const { firstFreeTimeslotdayjs, onClick } = props;
  const { t } = useTranslation();

  if (firstFreeTimeslotdayjs.isToday()) {
    return (
      <SearchCardFirstAvailabilityComponent
        fromText={t('available')}
        monthText={t('today')}
        onClick={onClick}
      />
    );
  }

  if (firstFreeTimeslotdayjs.isTomorrow()) {
    return (
      <SearchCardFirstAvailabilityComponent
        fromText={t('available')}
        monthText={t('tomorrow')}
        onClick={onClick}
      />
    );
  }

  // Any other date
  return (
    <SearchCardFirstAvailabilityComponent
      fromText={t('from')}
      fromDay={firstFreeTimeslotdayjs.format('ddd ')}
      dayText={firstFreeTimeslotdayjs.format('D')}
      monthText={firstFreeTimeslotdayjs.format('MMMM')}
      onClick={onClick}
    />
  );
};

export default SearchCardFirstAvailability;
